import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function CustomerStudioIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" fill="none" viewBox="0 0 40 40" {...props}>
      <Box
        as="path"
        fill="currentColor"
        fillRule="evenodd"
        d="M21.667 5a1.667 1.667 0 1 1 0 3.333H10c-.92 0-1.667.746-1.667 1.667v20c0 .92.747 1.667 1.667 1.667h1.833a8.337 8.337 0 0 1 16.334 0H30c.92 0 1.667-.747 1.667-1.667V16.667a1.667 1.667 0 1 1 3.333 0V30a5 5 0 0 1-5 5H10a5 5 0 0 1-5-5V10a5 5 0 0 1 5-5h11.667ZM20 28.333a5.002 5.002 0 0 0-4.715 3.334h9.43A5.002 5.002 0 0 0 20 28.333Z"
        clipRule="evenodd"
      />
      <Box
        as="path"
        fill="currentColor"
        fillRule="evenodd"
        d="M20 11.667a5.833 5.833 0 1 1 0 11.666 5.833 5.833 0 0 1 0-11.666ZM20 15a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
        clipRule="evenodd"
      />
      <Box
        as="path"
        fill="currentColor"
        d="M30.552 2.565c.258-1.198 1.97-1.198 2.228 0l.127.588a2.962 2.962 0 0 0 2.272 2.273l.588.126c1.199.258 1.199 1.97 0 2.228l-.588.127a2.962 2.962 0 0 0-2.272 2.272l-.127.588c-.258 1.199-1.97 1.199-2.228 0l-.126-.588a2.962 2.962 0 0 0-2.273-2.272l-.588-.127c-1.198-.259-1.198-1.97 0-2.228l.588-.126a2.962 2.962 0 0 0 2.273-2.273l.126-.588Z"
      />
    </Icon>
  );
}
